





























































































































































import Component, { mixins } from "vue-class-component";
import TextMonthChangePicker from "../common/TextMonthChangePicker.vue";
import TextDayChangePicker from "../common/TextDayChangePicker.vue";
import AxiosMixin from "../../mixins/axiosMixin";
import { Emit, Ref, Prop } from "vue-property-decorator";
import LoadingDialog from "../common/LoadingDialog.vue";
import VuetifyNumberInput from "../common/VuetifyNumberInput.vue";
import { MedicalExpense, DetailModel, JobDiv } from "./types";
import MedicalServiceDialog from "./MedicalServiceDialog.vue";
import { SelectItemString } from "@/types";
import EditDayChangePickerDialog from "@/components/common/EditDayChangePickerDialog.vue";

@Component({
  components: {
    TextMonthChangePicker,
    TextDayChangePicker,
    LoadingDialog,
    MedicalServiceDialog,
    VuetifyNumberInput,
    EditDayChangePickerDialog
  }
})
export default class DetailEditDialog extends mixins(AxiosMixin) {
  private detail: DetailModel | null = null;
  private isActive = false;
  private isDelete = false;
  @Prop() expense_type!: number;
  @Prop() burden_category_codes!: SelectItemString[]; //負担区分コード（画面用）
  @Prop() occupation_codes!: SelectItemString[]; //職種等コード
  @Prop() visit_frequency_codes!: SelectItemString[]; //訪問看護回数コード
  @Prop() instruction_classification_codes!: SelectItemString[]; //指示区分コード
  @Ref("serviceDialog") private readonly serviceDialog!: MedicalServiceDialog; //医療サービス検索ダイアログ

  //リアルタイム今日
  private today(): string {
    const date = new Date();
    date.setTime(date.getTime() + 1000 * 60 * 60 * 9);
    date.setDate(date.getDate());
    const today = date.toISOString().substr(0, 10);
    return today;
  }

  public open() {
    this.detail = {
      idx: -1,
      date_str: this.today(),
      burden_divs: [],
      medical_expense_code: "",
      amount: 0,
      price: 0,
      job_divs: [],
      visit_count_a_day: "",
      indicate_div: "",
      is_special_area: 0,
      premium_expense_code: "",
      name: "",
      step_calc_div: "0",
      disp_symbol1: "",
      disp_symbol2: "",
      disp_symbol3: "",
      disp_symbol4: "",
      disp_symbol5: "",
      disp_symbol6: "",
      disp_symbol7: "",
      disp_symbol8: "",
      disp_symbol9: ""
    };
    this.isActive = true;
    this.isDelete = true;
  }

  public openUpdate(detail: DetailModel) {
    this.detail = JSON.parse(JSON.stringify(detail));
    this.isActive = true;
    this.isDelete = false;
  }

  private clickDelete() {
    if (confirm("編集中の明細行を削除します。よろしいですか？")) {
      this.delete();
      this.isActive = false;
    }
  }

  private clickOk() {
    if (confirm("編集中の明細行を医療明細に反映します。よろしいですか？")) {
      this.update();
      this.isActive = false;
    }
  }

  private clickCancel() {
    this.isActive = false;
  }

  private addJob() {
    const jd: JobDiv = {
      job_div: ""
    };
    this.detail?.job_divs.push(jd);
  }

  private delJob(idx: number) {
    this.detail?.job_divs.splice(idx, 1);
  }

  //数量固定
  private editableAmount(): boolean {
    //きざみ値（きざみ値計算識別）が0の場合は数量編集できない
    if (this.detail?.step_calc_div == "0") {
      return true;
    }
    return false;
  }

  //サービス検索
  private clickSearchService() {
    if (this.detail !== null) {
      //算定年月が空の場合は検索できない
      if (this.detail.date_str == "" || this.detail.date_str == null) {
        alert("算定年月日がなければ検索できません。");
      }

      this.serviceDialog.open(
        this.detail.date_str,
        this.expense_type,
        this.detail.medical_expense_code,
        this.detail.name
      );
    }
  }

  //サービス選択
  private selectService(medicalExpense: MedicalExpense) {
    if (this.detail !== null) {
      this.detail.medical_expense_code = medicalExpense.medical_expense_code;
      this.detail.name = medicalExpense.expense_short_name;
      this.detail.price = medicalExpense.price;
      this.detail.step_calc_div = medicalExpense.step_calc_div;
      this.detail.disp_symbol1 = medicalExpense.disp_symbol1;
      this.detail.disp_symbol2 = medicalExpense.disp_symbol2;
      this.detail.disp_symbol3 = medicalExpense.disp_symbol3;
      this.detail.disp_symbol4 = medicalExpense.disp_symbol4;
      this.detail.disp_symbol5 = medicalExpense.disp_symbol5;
      this.detail.disp_symbol6 = medicalExpense.disp_symbol6;
      this.detail.disp_symbol7 = medicalExpense.disp_symbol7;
      this.detail.disp_symbol8 = medicalExpense.disp_symbol8;
      this.detail.disp_symbol9 = medicalExpense.disp_symbol9;
      //きざみ値（きざみ値計算識別）が0の場合は数量1で登録
      if (this.detail.step_calc_div == "0") {
        this.detail.amount = 1;
      }
    }
  }

  @Emit()
  update() {
    return this.detail;
  }

  @Emit()
  delete() {
    return this.detail;
  }
}
